import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  template:  `<footer class="main-footer">
      <div class="pull-right hidden-xs">
          <b>Version</b> 1.0.0
      </div>
      <strong>Copyright &copy; 2014-2018 <a href="https://adminlte.io">Tredia</a>.</strong> All rights
      reserved.
  </footer>`
})
export class FooterComponent  {

}
